import m from "mithril";
import { store } from "../models/store.js";
import { formatMoney, parseNumberInput } from "../services/format.js";

// The tally. Sums the ticked items, and — if you enter what the table actually
// paid — works out the tip per head and folds one head's share into your total.
// Example: dinner for 4, receipt €100, you paid €200 -> €25 tip per head.

export const Totals: m.Component = {
  view() {
    if (store.phase !== "ready") return null;

    const cur = store.currency;
    const selected = store.selectedTotal();
    const tip = store.tip();
    const tipHead = store.tipPerHead();
    const base = store.detectedTotal ?? store.itemsTotal();

    return m("section.totals", [
      m("div.total-line", [
        m("span", "Your items"),
        m("span.num", formatMoney(selected, cur)),
      ]),

      m("details.final-bill", [
        m("summary", "Add a tip / split the final bill"),
        m("div.final-grid", [
          m("label.field", [
            "Final bill paid",
            m("input", {
              type: "text",
              inputmode: "decimal",
              placeholder: base ? base.toFixed(2) : "e.g. 200",
              value: store.finalBill ?? "",
              oninput: (ev: Event) => {
                store.finalBill = parseNumberInput((ev.target as HTMLInputElement).value);
              },
            }),
          ]),
          m("label.field", [
            "People",
            m("input", {
              type: "text",
              inputmode: "numeric",
              value: store.people,
              oninput: (ev: Event) => {
                store.people = parseNumberInput((ev.target as HTMLInputElement).value) ?? 1;
              },
            }),
          ]),
        ]),
        m("p.hint", [
          "Receipt total used: ",
          m("strong", formatMoney(base, cur)),
          store.detectedTotal != null ? " (from the receipt)" : " (sum of items)",
        ]),
      ]),

      tip != null && tip !== 0
        ? m("div.tip-block", [
            m("div.total-line.sub", [
              m("span", tip > 0 ? "Tip in total" : "Under receipt by"),
              m("span.num", formatMoney(Math.abs(tip), cur)),
            ]),
            tip > 0
              ? m("div.total-line.sub", [
                  m("span", `Tip per head (${Math.max(1, store.people || 1)})`),
                  m("span.num", formatMoney(tipHead ?? 0, cur)),
                ])
              : null,
          ])
        : null,

      m("div.total-line.grand", [
        m("span", "You pay"),
        m("span.num", formatMoney(store.yourTotal(), cur)),
      ]),
      tipHead && tipHead > 0
        ? m("p.hint", "Your ticked items plus one head’s share of the tip.")
        : null,
    ]);
  },
};
